import React, { useEffect} from "react";
import toast from "react-hot-toast";
import { useSearchParams } from "react-router-dom";
import { loadScriptOnce } from "../utils/loadScript";
const { REACT_APP_HUBSPOT_PORTAL_ID } = process.env;


const VoterForm = () => {
  const [searchParams, ] = useSearchParams()
  const formIdFromUrl = searchParams.get("formid")
  const createHubSpotForm = (email) => {
    loadScriptOnce("https://js.hsforms.net/forms/shell.js").then(() => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: "na1",
          portalId: REACT_APP_HUBSPOT_PORTAL_ID,
          formId: formIdFromUrl,
          target: "#hubspotForm",
          onFormReady: function ($form) {
            const canvasserEmailInput = $form.querySelector('input[name="canvasser_email"]');
            if (canvasserEmailInput) canvasserEmailInput.value = email;
          },
        });
      }
    }).catch(() => toast.error("Could not load the form. Please try again."));
  };

  useEffect(() => {
    if (formIdFromUrl) {
      const searchParams = new URLSearchParams(window.location.search);
      const saveApiEmail = searchParams.get("CanvasserEmail");
      createHubSpotForm(saveApiEmail)
    } else {
      toast.error("Form Not found")
    }

  }, [formIdFromUrl]);

  return (
    <div className="lg:p-10">
      <h1 className="text-canvas-primary pb-2 border-b border-canvas-primary mb-12 font-semibold">
        Survey Form
      </h1>
      <div id="hubspotForm"></div>
    </div>
  );
};

export default VoterForm;
